{
    "Αθήνα": [
        "ΥΑ",
        "ΥΒ",
        "ΥΕ",
        "ΥΖ",
        "ΥΗ",
        "ΖΖ",
        "ΖΗ",
        "ΖΚ",
        "ΖΜ",
        "ΙΒ",
        "ΙΕ",
        "ΙΖ",
        "ΙΗ",
        "ΙΚ",
        "ΙΜ",
        "ΙΟ",
        "ΙΡ",
        "ΙΤ",
        "ΙΥ",
        "ΧΕ",
        "ΧΖ",
        "ΧΗ",
        "ΧΡ",
        "ΧΤ",
        "ΧΥ",
        "ΧΧ",
        "ΗΒ",
        "ΟΑ",
        "ΟΒ",
        "ΟΕ",
        "ΟΖ",
        "ΟΗ",
        "ΟΙ",
        "ΟΚ",
        "ΟΜ",
        "ΟΝ",
        "ΟΟ",
        "ΟΤ",
        "ΟΥ",
        "ΟΧ",
        "ΧΜ",
        "ΖΕ",
        "ΖΙ",
        "ΖΟ"
    ],
    "Πειραιάς": ["ΥΙ", "ΥΚ", "ΥΜ", "ΥΝ", "ΖΝ", "ΖΡ", "ΒΕ", "ΒΖ", "ΒΗ", "ΒΧ", "ΤΖ"],
    "Δυτική Αττική (Ελευσίνα)": ["ΥΟ", "ΥΡ", "ΥΤ", "ΖΤ", "ΒΝ", "ΒΡ"],
    "Ανατολική Αττική (Παλλήνη)": ["ΥΥ", "ΥΧ", "ΖΥ", "ΖΧ", "ΒΚ", "ΒΜ"],
    "Αιτωλοακαρνανία (Μεσολόγγι)": ["ΜΕ"],
    "Αιτωλοακαρνανία (Αγρίνιο)": ["ΑΙ", "ΤΗ"],
    "Αργολίδα (Ναύπλιο)": ["ΑΡ", "ΤΜ"],
    "Αρκαδία (Τρίπολη)": ["ΤΡ"],
    "Άρτα": ["ΑΤ"],
    "Αχαΐα (Πάτρα)": ["ΑΧ", "ΑΖ", "ΑΟ", "ΑΑ", "ΑΥ"],
    "Βοιωτία (Λιβαδειά)": ["ΒΙ", "ΒΥ"],
    "Γρεβενά": ["ΡΝ"],
    "Δράμα": ["ΡΜ", "ΤΟ"],
    "Δωδεκάνησα (Ρόδος)": ["ΡΟ", "ΡΚ", "ΡΥ", "ΡΧ"],
    "Δωδεκάνησα (Κως)": ["ΚΧ", "ΕΑ"],
    "Έβρος (Αλεξανδρούπολη)": ["ΕΒ", "ΜΧ"],
    "Έβρος (Ορεστιάδα)": ["ΟΡ"],
    "Εύβοια (Χαλκίδα)": ["ΧΑ", "ΕΗ", "ΕΙ"],
    "Ευρυτανία (Καρπενήσι)": ["ΚΗ"],
    "Ζάκυνθος": ["ΖΑ", "ΖΒ"],
    "Ηλεία (Πύργος)": ["ΗΑ", "ΗΕ"],
    "Ημαθία (Βέροια)": ["ΗΜ", "ΗΧ"],
    "Ηράκλειο": ["ΗΡ", "ΗΚ", "ΗΖ", "ΗΗ", "ΗΙ", "ΗΤ"],
    "Θεσπρωτία (Ηγουμενίτσα)": ["ΗΝ"],
    "Θεσσαλονίκη": [
        "ΝΑ",
        "ΝΒ",
        "ΝΕ",
        "ΝΖ",
        "ΝΗ",
        "ΝΙ",
        "ΝΚ",
        "ΝΜ",
        "ΝΝ",
        "ΝΟ",
        "ΝΡ",
        "ΝΤ",
        "ΝΥ",
        "ΝΧ"
    ],
    "Ιωάννινα": ["ΙΝ", "ΙΙ"],
    "Καβάλα": ["ΚΒ", "ΑΒ"],
    "Καρδίτσα": ["ΚΑ", "ΜΚ"],
    "Καστοριά": ["ΚΤ"],
    "Κέρκυρα": ["ΚΥ", "ΕΤ", "ΤΒ", "ΤΕ"],
    "Κεφαλληνία (Αργοστόλι)": ["ΚΕ"],
    "Κιλκίς": ["ΚΙ", "ΕΧ"],
    "Κοζάνη": ["ΚΖ", "ΜΝ"],
    "Κορινθία": ["ΚΡ", "ΡΒ"],
    "Κυκλάδες (Ερμούπολη)": ["ΕΜ", "ΕΖ", "ΕΝ", "ΕΟ"],
    "Λακωνία (Σπάρτη)": ["ΑΚ", "ΜΡ"],
    "Λάρισα": ["ΡΙ", "ΡΡ", "ΡΤ"],
    "Λασίθι (Άγιος Νικόλαος)": ["ΑΝ", "ΑΕ"],
    "Λέσβος (Μυτιλήνη)": ["ΜΥ", "ΜΤ"],
    "Λέσβος (Μύρινα Λήμνου)": ["ΜΗ"],
    "Λευκάδα": ["ΕΥ"],
    "Μαγνησία (Βόλος)": ["ΒΟ", "ΒΒ", "ΒΑ", "ΒΤ"],
    "Μεσσηνία (Καλαμάτα)": ["ΚΜ", "ΜΖ"],
    "Ξάνθη": ["ΑΗ", "ΗΟ"],
    "Πέλλα (Έδεσσα)": ["ΕΕ", "ΜΜ"],
    "Πιερία (Κατερίνη)": ["ΚΝ", "ΤΙ"],
    "Πρέβεζα": ["ΡΖ", "ΤΧ"],
    "Ρέθυμνο": ["ΡΕ", "ΡΗ"],
    "Ροδόπη (Κομοτηνή)": ["ΚΟ", "ΚΚ", "ΤΤ"],
    "Σάμος": ["ΜΟ", "ΜΒ"],
    "Σέρρες": ["ΕΡ", "ΙΧ"],
    "Τρίκαλα": ["ΤΚ", "ΤΝ"],
    "Φθιώτιδα (Λαμία)": ["ΜΙ", "ΗΥ"],
    "Φλώρινα": ["ΡΑ"],
    "Φωκίδα (Άμφισσα)": ["ΑΜ"],
    "Χαλκιδική (Πολύγυρος)": ["ΧΚ", "ΜΑ"],
    "Χανιά": ["ΧΝ", "ΧΒ", "ΤΥ"],
    "Χίος": ["ΧΙ", "ΧΟ"]
}
